exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* .button {\n    position: relative;\n    right: 60px;\n    border: none;\n    background-color: white;\n} */\n\n.container__CompanySelection-module___2sfR6 {\n    position: relative;\n\n}\n.flexContainer__CompanySelection-module___6Ml_4 {\n    display: flex;\n    gap:10px;\n    background-color: white;\n     height: 36px;\n     width: 100% ;\n}\n\n.button__CompanySelection-module___2W5Ry {\n    min-width: 55px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "container__CompanySelection-module___2sfR6",
	"flexContainer": "flexContainer__CompanySelection-module___6Ml_4",
	"button": "button__CompanySelection-module___2W5Ry"
};